/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useHistory } from 'react-router-dom';

const cardContainer = css`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 20px;
`;

const auditCard = css`
    border: 1px solid #d1d1d1;
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        transform: translateY(-2px);
        border-color: #0078d4;
    }
`;

const cardTitle = css`
    font-size: 16px;
    font-weight: 600;
    color: #323130;
    margin: 0;
    line-height: 1.4;
`;

const AuditContainer = () => {
    const history = useHistory();

    const auditCards = [
        {
            title: "Cobrands with SSO only but have manual signups in the last 30 days",
            route: "/audits/sso-vs-manual"
        }
    ];

    const handleCardClick = (route) => {
        history.push(route);
    };

    return (
        <div className="container">
            <h1>Audits</h1>
            <p>Select an audit to view detailed information and reports.</p>
            <hr />
            
            <div css={cardContainer}>
                {auditCards.map((card, index) => (
                    <div 
                        key={index}
                        css={auditCard}
                        onClick={() => handleCardClick(card.route)}
                    >
                        <h3 css={cardTitle}>{card.title}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AuditContainer;
